/* candy-product-core.js — the shared half of the product page (split 2026-09).
   ==========================================================================
   The product page used to be ONE section and ONE IIFE, so money(), the
   lightbox, the carousel hand-off and the rec-card Add delegation were just
   closure variables that everything could reach. Six sections cannot share a
   closure, and all four of those things are genuinely page-wide rather than
   band-wide, so they live here instead.

   EVERY prd7k9 section loads this file. Classic <script src> elements are NOT
   de-duplicated by URL the way ES modules are — six tags means one fetch and
   SIX evaluations — so the first line is the guard that makes evaluations
   2..6 free. Do not turn this into type="module": a module nulls out
   document.currentScript and defers past DOMContentLoaded.

   Nothing in here reaches into a band. It is asked for things; it never goes
   looking for a section to drive. The one exception is logRecent() at the
   bottom, and that is deliberate. */
(function(){
  'use strict';
  if(window.CandyPrd) return;

  /* ================= money =================================================
     Every wrapper that prints a price carries data-money-format, and all of
     them render the same {{ shop.money_format | escape }}, so which section
     loaded first is irrelevant. Resolved LAZILY on the first money() call
     rather than at init, so this file never depends on a particular band
     existing: seeded explicitly by whichever module got there first, else read
     off the first wrapper in document order, else a bare pound sign. The
     fallback is deliberately not cached, so a call that somehow runs before
     any wrapper exists cannot poison the value for the rest of the page. */
  var FMT = '';
  function useMoneyFormat(s){ if(!FMT && s) FMT = s; return FMT; }
  function money(cents){
    var f = FMT;
    if(!f){
      var el = document.querySelector('[data-money-format]');
      if(el) f = FMT = el.getAttribute('data-money-format') || '';
    }
    if(!f) f = '\u00a3{{amount}}';
    var v = (cents / 100).toFixed(2);
    /* the tag strip is for money formats that ship markup, e.g.
       "<span class=money>${{amount}} CAD</span>" — the attribute is escaped by
       Liquid and un-escaped again by the HTML parser, so by the time it reaches
       here the tags are real characters. */
    return f.replace(/\{\{\s*[a-z_]+\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  /* ================= the lightbox ==========================================
     ONE overlay for the page, created on first use and parked on <body>.
     It is opened by the gallery zoom (Product) and by every What's-inside tile,
     which are now two different sections that can be reordered, hidden or
     deleted independently — so neither of them can own it. Body-level also
     means a theme-editor re-render of either band cannot pull the node out
     from under a cached reference; isConnected below re-checks anyway.

     Every rule it needs is element-scoped (candy-product.css:94-108, 966-971;
     the file's own note at :93 says the overlay is meant to be a sibling of the
     section root), so it needs no .custom-prd7k9 ancestor. The ONE thing it
     loses out there is `.custom-prd7k9 *{box-sizing:border-box}` at :30, which
     is restored by the box-sizing rule added at the end of candy-product.css.

     If a Liquid-rendered .custom-prd7k9__lightbox is already on the page it is
     adopted rather than duplicated, so this is safe mid-migration and safe if
     anyone ever puts the markup back. */
  var BLANK = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  var lb = null, lbImg = null;

  function lbNode(){
    if(lb && lb.isConnected) return lb;
    lb = document.querySelector('.custom-prd7k9__lightbox');
    if(!lb){
      lb = document.createElement('div');
      lb.className = 'custom-prd7k9__lightbox';
      lb.setAttribute('data-lightbox', '');
      /* a 1x1 transparent GIF, not src="": an empty src re-requests the page
         URL in some engines and licenses a broken-image glyph in others. */
      lb.innerHTML =
        '<button type="button" class="custom-prd7k9__lightbox-x" data-lightbox-x aria-label="Close">&times;</button>' +
        '<img width="1600" height="1600" data-lightbox-img src="' + BLANK + '" alt="" />';
      document.body.appendChild(lb);
    }
    lbImg = lb.querySelector('[data-lightbox-img]');
    if(!lb.__c4uLbBound){
      lb.__c4uLbBound = true;
      lb.addEventListener('click', function(e){
        if(e.target === lb || (e.target.closest && e.target.closest('[data-lightbox-x]'))) closeLb();
      });
    }
    return lb;
  }

  function closeLb(){
    if(!lb) return;
    lb.removeAttribute('open');
    document.documentElement.style.overflow = '';
  }

  /* Reserve the final box from the already-loaded thumbnail, otherwise an
     auto-sized img stays 0x0 until the new file exposes its metadata and the
     shimmer appears late. 4:5 is the fallback shape. Verbatim from the old
     candy-product.js:189-200. */
  function sizeLb(sourceImg){
    var naturalW = sourceImg && (sourceImg.naturalWidth || parseFloat(sourceImg.getAttribute('width')));
    var naturalH = sourceImg && (sourceImg.naturalHeight || parseFloat(sourceImg.getAttribute('height')));
    if(!naturalW || !naturalH){ naturalW = 4; naturalH = 5; }
    var viewportW = document.documentElement.clientWidth || window.innerWidth;
    var viewportH = document.documentElement.clientHeight || window.innerHeight;
    var maxW = Math.min(viewportW * (viewportW <= 768 ? 0.893333 : 0.78), 1280);
    var maxH = viewportH * 0.78;
    var scale = Math.min(maxW / naturalW, maxH / naturalH);
    lbImg.style.width  = (Math.max(1, Math.round(naturalW * scale)) / window.innerWidth * 100) + 'vw';
    lbImg.style.height = (Math.max(1, Math.round(naturalH * scale)) / window.innerWidth * 100) + 'vw';
  }

  function openLb(src, alt, sourceImg){
    if(!src) return;
    lbNode();
    /* The lightbox reuses one img node, so reset the global skeleton before
       changing its source: candy-head's delegated load listener puts
       candy-ready back when the new file lands. */
    sizeLb(sourceImg);
    lbImg.classList.remove('candy-ready', 'candy-fade');
    lbImg.classList.add('candy-near');
    lbImg.src = src;
    lbImg.alt = alt || '';
    lb.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && lb && lb.hasAttribute('open')) closeLb();
  });

  /* Both triggers are DELEGATED on document, in one place, because they now
     live in two different sections that the merchant can reorder, hide or
     re-render independently. A per-button binding in the What's-inside section
     would come back unbound after a theme-editor re-render of that section,
     because the OTHER section's script does not re-run. */
  if(!window.__c4uLbTriggersBound){
    window.__c4uLbTriggersBound = true;
    document.addEventListener('click', function(e){
      if(!e.target.closest) return;
      var z = e.target.closest('[data-inside-zoom]');
      if(z){
        e.preventDefault(); e.stopPropagation();
        var item = z.closest('.custom-prd7k9__inside-i');
        var thumb = item && item.querySelector('.custom-prd7k9__inside-media img');
        openLb(z.getAttribute('data-inside-zoom-src'), z.getAttribute('data-inside-zoom-alt'), thumb);
        return;
      }
      var g = e.target.closest('[data-zoom]');
      if(!g) return;
      var host = g.closest('.custom-prd7k9') || document;
      var on = host.querySelector('.custom-prd7k9__slide--on img');
      if(on) openLb(on.currentSrc || on.src, on.alt || '', on);
    });
  }

  /* ================= the bsl3k rails =======================================
     Hand a row to the shared carousel engine. `scope` may BE the
     .custom-prd7k9__bsl3k box or contain one — "Recently viewed" passes the box
     it just filled, "Goes well with" passes its section root.

     The box handed over must be the DIRECT PARENT of .custom-bsl3k__viewport:
     the engine inserts its dot rail as root's next child after the viewport
     (candy-bsl3k-slider.js:211-219 and :377-382, and the contract is spelled
     out in that file's header at :17-20). NEVER pass the <section> — the
     viewport's next sibling is then a whitespace text node that is not a child
     of the section, insertBefore throws NotFoundError, and the engine aborts
     before the dots, the arrows, the drag, measure()/render() and the
     custom-bsl3k--ready class. The row freezes in the pre-init CSS pose.

     __bsl3kWired is the engine's own flag; checking it here keeps a live rail
     out of the queue, so a real ordering bug cannot hide behind the engine's
     silent no-op. */
  function rails(scope){
    if(!scope) return;
    var boxes = [];
    if(scope.matches && scope.matches('.custom-prd7k9__bsl3k')) boxes.push(scope);
    if(scope.querySelectorAll){
      boxes = boxes.concat(Array.prototype.slice.call(scope.querySelectorAll('.custom-prd7k9__bsl3k')));
    }
    boxes.forEach(function(box){
      var rail = box.querySelector('.custom-bsl3k__rail');
      if(!rail || !rail.children.length) return;
      /* same guard candy-top-sellers applies in Liquid with `shown > 1`; the
         difference is only that "Recently viewed" does not know its count
         until JS has built it */
      var navrow = box.querySelector('.custom-bsl3k__navrow');
      if(navrow) navrow.hidden = rail.children.length < 2;
      if(box.__bsl3kWired) return;
      (window.__bsl3kQueue = window.__bsl3kQueue || []).push(box);
    });
    /* drained unconditionally: a sibling section may have queued a row while
       the engine was still in flight, and this is the call that picks it up */
    if(window.candyBsl3kDrain) window.candyBsl3kDrain();
  }
  /* compatibility alias for anything still calling the old global */
  window.__prd7k9RecsRails = function(scope){ rails(scope || document); };

  /* ================= rec-card Add -> shared quick-buy ======================
     Capture phase so a click on the pill never follows the card link. Bound
     ONCE for the whole page; matches both the server-rendered "Goes well with"
     cards and the JS-built "Recently viewed" cards, which is precisely why it
     cannot live in either of those two sections any more.

     Copied verbatim from candy-product.js:659-673 except that the dead
     .custom-prd7k9__rec-add arm is dropped: snippets/candy-rec-card.liquid,
     the only emitter of that class, is rendered nowhere in the theme. The
     __bsl3kAddBound test stays INSIDE the handler and is evaluated at CLICK
     time on purpose — candy-top-sellers-section.js may bind after this file,
     and stopPropagation does not stop a sibling listener on the same node. */
  if(!window.__prd7k9RecAddBound){
    window.__prd7k9RecAddBound = true;
    document.addEventListener('click', function(e){
      if(window.__bsl3kAddBound) return;
      var btn = e.target.closest ? e.target.closest('.custom-bsl3k__add[data-handle]') : null;
      if(!btn) return;
      e.preventDefault(); e.stopPropagation();
      if(window.candyQuickBuy) window.candyQuickBuy(btn);
    }, true);
  }

  /* ================= recently-viewed store =================================
     The LIST is page-wide state; only the STRIP is a section. Splitting them is
     what keeps "this product gets logged into the visitor's history" from
     becoming a side effect of a merchant hiding one band — today the
     [data-prd-recent] blob renders unconditionally, above the show_recent
     check, and the write-back runs whether or not the strip is on.

     Reads the FIRST [data-prd-recent] in the document, so it does not care
     which section renders it. Both the Product section and the Recently Viewed
     section emit an identical blob; the second one is inert.

     othersCache is computed BEFORE the write-back and cached, so the strip gets
     the same pre-write list whichever of the two runs first. */
  var RKEY = 'candy:recent';
  var meSeed, othersCache = null;

  function recentSeed(){
    if(meSeed !== undefined) return meSeed;
    meSeed = null;
    var el = document.querySelector('[data-prd-recent]');
    if(el){ try{ meSeed = JSON.parse(el.textContent); }catch(e){ meSeed = null; } }
    return meSeed;
  }

  function recentOthers(){
    if(othersCache) return othersCache;
    var list = [];
    try{ list = JSON.parse(localStorage.getItem(RKEY) || '[]'); }catch(e){ list = []; }
    if(!list || !list.length) list = [];
    var me = recentSeed();
    /* the x.h test is new: a nil `product` used to leave me.h undefined, which
       filtered nothing out and then pushed a junk entry onto everyone's list */
    othersCache = list.filter(function(x){
      return x && x.h && (!me || !me.h || x.h !== me.h);
    });
    return othersCache;
  }

  /* NAVIGATION FIELDS ONLY (client 2026-09-08: "Fizzy Chips is From GBP4.95 in the grid and
     GBP5.25 in Staff Picks and Recently Viewed. Same product, two prices on one page. Find why.")
     The blob used to carry the price and the whole variant list, and an entry is written ONCE, on
     the visit - nothing ever refreshes it. So when Fizzy Chips' Teaser Pouch went 5.25 -> 4.95 on
     2026-09-05, every browser that had already seen the product kept rendering 5.25 out of
     localStorage next to the server's live 4.95. Proved on the live site: a seeded entry rendered
     its stored title verbatim on a fresh page load.
     A history row is navigation, so it now stores only what a link needs - handle, title, url,
     image. A price that cannot be stored cannot go stale. Title and image can still age, but they
     are cosmetic and are refreshed the moment the visitor opens that product again.
     Entries written before this change still hold p/v; they are simply not read. */
  function trim(x){
    return x && x.h ? { h: x.h, t: x.t, u: x.u, i: x.i } : null;
  }

  function logRecent(){
    if(window.__c4uRecentLogged) return;
    var me = recentSeed();
    if(!me || !me.h) return;
    window.__c4uRecentLogged = true;
    var out = recentOthers().map(trim).filter(Boolean);
    out.unshift(trim(me));
    try{ localStorage.setItem(RKEY, JSON.stringify(out.slice(0, 8))); }catch(e){}
  }

  /* ================= section plumbing ======================================
     ready(selector, fn) — call fn(root) once per matching root, now and again
     whenever the theme editor re-renders a section containing one.

     This REPLACES document.currentScript.closest() as the anchor. Whether
     Shopify's editor re-executes a section's <script src> on re-render is not
     settled by anything in this theme, and ready() converges on the same state
     under both answers: a fresh root has no flag so it initialises, an
     untouched root has one so it does not. It also handles two copies of the
     same section, and it makes the second evaluation of a shared file free. */
  var WATCHED = {};
  function ready(sel, fn){
    function run(scope){
      var roots = [];
      if(scope.matches && scope.matches(sel)) roots.push(scope);
      if(scope.querySelectorAll){
        roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(sel)));
      }
      roots.forEach(function(r){
        var done = r.__c4uPrd || (r.__c4uPrd = {});
        if(done[sel]) return;
        done[sel] = true;
        /* one band that throws must not take the other five down with it */
        try{ fn(r); }
        catch(e){ if(window.console && console.error) console.error('[CandyPrd]', sel, e); }
      });
    }
    run(document);
    if(WATCHED[sel]) return;          /* the file may be evaluated once per section */
    WATCHED[sel] = true;
    document.addEventListener('shopify:section:load', function(e){ run(e.target); });
  }

  /* onWindow(root, type, fn) — a window listener that belongs to a root: it
     removes itself the first time it fires after that root has left the
     document. The gallery, the thumb rail and the sticky bar all bind
     resize/scroll/load on window; without this, every theme-editor re-render
     leaves another copy behind measuring a detached subtree. */
  function onWindow(root, type, fn, opts){
    function h(e){
      if(root && !root.isConnected){ window.removeEventListener(type, h, opts); return; }
      fn(e);
    }
    window.addEventListener(type, h, opts);
    return h;
  }

  /* let a band tear down anything onWindow cannot reach — the wishlist
     subscription is the only such thing today (candy-wishlist.js keeps an
     append-only subs array and nothing ever calls off()) */
  document.addEventListener('shopify:section:unload', function(e){
    if(!e.target || !e.target.querySelectorAll) return;
    Array.prototype.forEach.call(e.target.querySelectorAll('.custom-prd7k9'), function(r){
      if(typeof r.__c4uUnload === 'function'){ try{ r.__c4uUnload(); }catch(err){} }
    });
  });

  window.CandyPrd = {
    money: money,
    useMoneyFormat: useMoneyFormat,
    lightbox: { open: openLb, close: closeLb, node: lbNode },
    rails: rails,
    recentSeed: recentSeed,
    recentOthers: recentOthers,
    logRecent: logRecent,
    ready: ready,
    onWindow: onWindow
  };

  /* Logging is page-wide, not band-wide: it runs as soon as ANY prd7k9 section
     has loaded this file and SOME section carries the seed. Deferred scripts
     run after the whole document is parsed, so the seed is reachable here no
     matter which band renders it or where it sits. */
  logRecent();
})();